import { MagnifyingGlass } from '@phosphor-icons/react';
import { Button } from '../ui/button';

const TRENDING = ['Sur-Ron', 'helmet', 'battery', 'gloves', 'eMTB', 'hoodie'];

const CATEGORIES = [
    { id: 'all', label: 'All' },
    { id: 'vehicles', label: 'Vehicles' },
    { id: 'parts', label: 'Parts & Motors' },
    { id: 'gear', label: 'Riding Gear' },
    { id: 'merch', label: 'Merch' },
    { id: 'streetwear', label: 'Streetwear' },
];

export function ShopSearchBar({ search, setSearch, searchFocused, setSearchFocused, recentSearches, commitSearch, category, setCategory }) {
    return (
        <div className="space-y-3">
            <div className="relative">
                <MagnifyingGlass size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
                <input
                    type="text"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    onFocus={() => setSearchFocused(true)}
                    onBlur={() => setTimeout(() => setSearchFocused(false), 200)}
                    onKeyDown={e => { if (e.key === 'Enter') commitSearch(search); }}
                    placeholder="Search bikes, gear, parts..."
                    className="w-full bg-white/5 border border-white/10 rounded-xl pl-10 pr-4 py-2.5 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-primary/40 transition-colors"
                    data-testid="marketplace-search"
                />
                {search && (
                    <button onClick={() => setSearch('')}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground text-xs">
                        Clear
                    </button>
                )}

                {searchFocused && !search && (
                    <div className="absolute top-full left-0 right-0 mt-1 bg-card border border-border rounded-xl shadow-lg z-30 overflow-hidden"
                        data-testid="search-suggestions">
                        {recentSearches.length > 0 && (
                            <div className="p-3 border-b border-border/50">
                                <p className="text-[10px] font-display text-muted-foreground tracking-wider mb-2">RECENT</p>
                                <div className="flex flex-wrap gap-1.5">
                                    {recentSearches.map(s => (
                                        <button key={s} onMouseDown={() => commitSearch(s)}
                                            className="px-2.5 py-1 text-xs bg-white/5 border border-white/10 rounded-full text-foreground hover:border-primary/30 transition-colors">
                                            {s}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )}
                        <div className="p-3">
                            <p className="text-[10px] font-display text-muted-foreground tracking-wider mb-2">TRENDING</p>
                            <div className="flex flex-wrap gap-1.5">
                                {TRENDING.map(s => (
                                    <button key={s} onMouseDown={() => commitSearch(s)}
                                        className="px-2.5 py-1 text-xs bg-primary/5 border border-primary/10 rounded-full text-primary hover:bg-primary/10 transition-colors">
                                        {s}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
                {CATEGORIES.map((cat) => (
                    <Button key={cat.id} variant={category === cat.id ? 'default' : 'outline'} size="sm"
                        onClick={() => setCategory(cat.id)}
                        className={`rounded-full whitespace-nowrap ${category === cat.id ? 'btn-primary' : ''}`}
                        data-testid={`category-${cat.id}`}>
                        {cat.label}
                    </Button>
                ))}
            </div>
        </div>
    );
}
